/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />

window.JJK = window.JJK || {};

JJK.Login = function (loginButtonName, action) {
	this.loginButtonName = loginButtonName;
	this.action = action !== 'undefined' ? action : '';
	this.Init();
};
JJK.Login.prototype = {
	passwordTextSelector: '#Kennwort',
	loginButtonName: '',
	action: '',
	validator: null,

	Init: function () {
		const self = this;

		$(`#${this.loginButtonName}`).on('click', function () {
			self.Submit();
		});

		$(this.passwordTextSelector).on('keydown', function (e) {
			if (e.which === 13) {
				e.preventDefault();
				self.Submit();
			}
		});

		$('#login-mit-email, #login-mit-email-kundendaten').on('click', evt => {
			evt.preventDefault();
			const email = $('#EmailLogin').val();
			if (email === '') {
				$('#LoginForm').validate({ focusInvalid: true }).element('#EmailLogin');
				$('#EmailLogin').trigger('focus');
			} else {
				$('#LoginPerMailWorkflow').val(true);
				self.Submit();
			}
		});

		// Wenn jQuery-Validate geladen ist, dieses auch verwenden
		if ($.fn.validate) {
			const validateOptions = {
				rules: {
					EmailLogin: 'required',
					Kennwort: {
						required: {
							depends: () => ($('#LoginPerMailWorkflow').val() || 'false').toLowerCase() === 'false',
						},
					},
				},
				messages: {
					EmailLogin: Strings.BenutzernameNichtGefuellt,
					Kennwort: Strings.KennwortNichtGefuellt,
				},
				errorClass: 'error small',
				focusInvalid: true,
			};
			if ($('#loginValidateErrors').length) {
				// Für Zusammenfassung über der Form:
				validateOptions.errorLabelContainer = '#loginValidateErrors';
				validateOptions.errorElement = 'li';
			} else {
				// Für einzelne Meldungen direkt unter den Feldern:
				validateOptions.errorElement = 'span';
			}
			this.validator = $('#LoginForm').validate(validateOptions);
			// beim input event auch validieren, damit nach einem fehlgeschlagenen validate und anschließendem "autofill" vom Browser (gespeicherte Login-Daten) direkt validiert wird
			$('#EmailLogin, #Kennwort').on('input', function () {
				if ($(this).val()) {
					$('#LoginForm').validate().element(this);
				}
			});
		}
		$('div.dropdown-menu.login-menu').on('click', function (e) {
			e.stopPropagation();
		});
	},

	Submit: function () {
		// Wenn jQuery-Validate geladen ist, dann muss es valid sein
		if (!$.fn.validate || $('#LoginForm').valid()) {
			submit_form_default('', 'LoginForm');
		} else {
			this.validator.focusInvalid();
		}
	},
};
